import { Directive, HostBinding } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[vertical]',
  standalone: false,
})
export class VerticalLayoutDirective {
  @HostBinding('class.is-vertical') isVertical = true;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[horizontal]',
  standalone: false,
})
export class HorizontalLayoutDirective {
  @HostBinding('class.is-horizontal') isHorizontal = true;
}
